<template>
  <BaseVeeForm :action="submit">
    <!-- formProps
      isIdle, isPending, isResolved, isRejected, invalid
      errors, submit
    -->
    <template #default="formProps">
      <BaseCard class="max-w-lg w-full mx-auto">
        <BaseCardHeader>
          <h3 class="text-base font-medium">Delete Sms message</h3>
        </BaseCardHeader>
        <BaseCardBody>
          <p>Are you sure you want to delete this SMS Message?</p>
        </BaseCardBody>
        <BaseCardFooter gray>
          <BaseButton primary :disable="formProps.isPending"> Delete </BaseButton>
        </BaseCardFooter>
      </BaseCard>
    </template>
  </BaseVeeForm>
</template>

<script>
import { smsMessagesClient } from '@/api/clients';

export default {
  props: {
    smsMessage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    submit() {
      return smsMessagesClient.destroy(this.smsMessage.id).then(() => {
        this.$emit('sms-message:deleted');

        return Promise.resolve();
      });
    },
  },
};
</script>
